<template>
  <div>
    <!-- BIENVENIDA SUPERPUESTA -->
    <div v-if="showWelcome" class="bienvenida-overlay" ref="overlayBienvenida">
      <div class="bienvenida-card" ref="welcomeCard">
        <p class="titulo-bienvenida">
          Bienvenidos a la invitación de<br />
          Jazmín y Alan
        </p>
        <button @click="ocultarBienvenida">Ingresar</button>
      </div>
    </div>

    <!-- SECCIÓaasdasdasdasdassdfsdfdjkhkjhkjhkjhkjkjlkjkjlkjlkjlkjlkjlkjasdasdasdasddfasdadAL -->
    <transition name="fade">
      <div v-if="isVisible" class="fotoportada-container" ref="portadaRef">
        <img
          src="@/assets/IMG_7701.webp"
          alt="Imagen de portada"
          class="fotoportada-img"
          ref="imagenPortada"
          loading="eager"
          decoding="async"
          fetchpriority="high"
        />

        <div class="overlay">
          <button class="hamburger" aria-label="Menú">
            <span></span><span></span><span></span>
          </button>

          <div class="texto-inferior" ref="textoInferiorRef">
            <h1 class="script-nombres">{{ nombresLinea }}</h1>
            <p class="script-fecha">{{ fechaLinea }}</p>
          </div>
        </div>

        <div class="footer-bar">
          <div class="footer-text">JAZMÍN RUBÍ<br />ALAN ADAHIR</div>
          <div class="footer-menu"><i class="fas fa-bars"></i></div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { ref, nextTick, onMounted, onBeforeUnmount } from 'vue'
import { gsap } from 'gsap'

export default {
  name: 'PortadaBodaElegante',
  props: {
    nombresLinea: { type: String, default: 'Jazmín y Alan ' },
    fechaLinea:   { type: String, default: '05 de Diciembre de 2026' }
  },
  setup () {
    const isVisible = ref(true)
    const showWelcome = ref(true)

    const portadaRef = ref(null)
    const imagenPortada = ref(null)
    const textoInferiorRef = ref(null)

    const welcomeCard = ref(null)
    const overlayBienvenida = ref(null)

    const animarTexto = () => {
      if (!textoInferiorRef.value) return
      gsap.from(textoInferiorRef.value.children, {
        y: 22,
        opacity: 0,
        duration: 0.9,
        stagger: 0.12,
        ease: 'power3.out'
      })
    }

    const ocultarBienvenida = () => {
      gsap.timeline({
        onComplete: () => {
          showWelcome.value = false
          animarTexto()
        }
      })
      .to(welcomeCard.value, { y: 10, opacity: 0, duration: 0.35, ease: 'power2.out' })
      .to(overlayBienvenida.value, { opacity: 0, duration: 0.35, ease: 'power2.out' }, '<')
    }

    onMounted(() => {
      // Entrada SOLO de esta tarjeta (no global)
      gsap.fromTo(welcomeCard.value,
        { opacity: 0, y: 20 },
        { opacity: 1, y: 0, duration: 0.8, delay: 0.25, ease: 'power2.out' }
      )

      nextTick(() => {
        if (imagenPortada.value?.src) {
          const preload = new Image()
          preload.src = imagenPortada.value.src
        }
      })
    })

    onBeforeUnmount(() => {
      // Evita que queden animaciones vivas afectando otros componentes
      gsap.killTweensOf([welcomeCard.value, overlayBienvenida.value])
      if (textoInferiorRef.value) gsap.killTweensOf(textoInferiorRef.value.children)
    })

    return {
      isVisible,
      showWelcome,
      ocultarBienvenida,
      portadaRef,
      imagenPortada,
      textoInferiorRef,
      welcomeCard,
      overlayBienvenida
    }
  }
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@400;600&family=Great+Vibes&display=swap');

.fade-enter-active, .fade-leave-active { transition: opacity .3s ease; }
.fade-enter-from,  .fade-leave-to      { opacity: 0; }

.fotoportada-container { margin-top:-60px;position: relative; width: 100%; height: 100vh; overflow: hidden; }
.fotoportada-img { width: 100%; height: 100%; object-fit: cover; will-change: auto; }

.overlay{
  position: absolute;
  inset: 0;
  background: linear-gradient(
    to bottom,
    rgba(0, 0, 0, 0.715) 0%,
    rgba(0, 0, 0, 0.187) 35%,
    rgba(0, 0, 0, 0.12) 70%,
    rgba(0, 0, 0, 0) 100%
  );
  z-index: 2;
}
.hamburger { position: absolute; top: 14px; right: 14px; width: 28px; height: 22px; display: grid; gap: 5px; background: transparent; border: 0; padding: 0; z-index: 3; }
.hamburger span { display: block; height: 2px; background: #fff; border-radius: 1px; }

.texto-inferior { position: absolute; left: 0; right: 0; top: 95px; text-align: center; padding: 0 14px; z-index: 3; }
.script-nombres {   font-family: 'Playfair Display', serif;
 font-size: 46px; line-height: 1.1; color: #fff; text-shadow: 0 2px 6px rgba(0,0,0,.35); font-weight: 400; letter-spacing: 1px; margin: 0 0 10px 0; }
.script-fecha   { font-family: 'Playfair Display', serif; font-size: clamp(19px, 3.6vw, 18px); letter-spacing: 2.5px; color: #fff; margin: 0; text-shadow: 0 2px 6px rgba(0,0,0,.35); }

.footer-bar { position: absolute; bottom: 0; width: 100%; height: 54px; background-color: rgba(161,151,142,.95); display: flex; justify-content: space-between; align-items: center; padding: 0 20px; color: #fff; font-family: 'Playfair Display', serif; font-size: 11px; letter-spacing: 1px; z-index: 4; }
.footer-text { line-height: 1.2; text-align: left; }
.footer-menu { font-size: 18px; }

.bienvenida-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: white;
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
}

.bienvenida-card {
  text-align: center;
  padding: 40px;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
}

.titulo-bienvenida {
  font-size: 14px;
  margin-bottom: 30px;
  font-family: 'Playfair Display', serif;
  color: #333;
}

.bienvenida-card button {
  background-color: #3d3d3d;
  color: white;
  font-size: 14px;
  border: none;
  padding: 10px 24px;
  border-radius: 30px;
  cursor: pointer;
  transition: background 0.3s;
}

.bienvenida-card button:hover {
  background-color: #222;
}</style>
